import { render, staticRenderFns } from "./template.vue?vue&type=template&id=ad773228&scoped=true"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=ad773228&prod&lang=scss"
import style1 from "./template.vue?vue&type=style&index=1&id=ad773228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad773228",
  null
  
)

export default component.exports